import PostMessageEventHandler from "../post_message/post_message_event_handler";
import { ProcessStore } from "../process/reflux/process_store";
import { ActivityFormEventHandler, ActivityFormEvents } from "../process/events/activity_form_event_handler";

import { ProcessAPI, FlashMessageAPI } from 'lecom-api';

export const approveForm = () => {
	const formAPI = ProcessAPI.currentProcess().form();
	const action = formAPI.actions('aprovar') || formAPI.actions('finish');

	!!action
	? action.execute()
	: publishMultipleCompleteActivityActionFailed('activity.messages.multipleApprovalFailed');
};

export const rejectForm = () => {
	const formAPI = ProcessAPI.currentProcess().form();
	const action = formAPI.actions('rejeitar') || formAPI.actions('cancel');

	!!action
		? action.execute()
		: publishMultipleCompleteActivityActionFailed('activity.messages.multipleRejectionFailed');
};

const publishMultipleCompleteActivityActionFailed = (messageKey) => {
	let flashAPI = FlashMessageAPI.flash("flash-form");
	flashAPI.addMessage({
		message: Realize.i18n.t(messageKey),
		type: 'warning'
	});

	const processInstanceData = ProcessAPI.currentProcess().processInstanceData();

	ActivityFormEventHandler.publish(ActivityFormEvents.MULTIPLE_COMPLETE_ACTIVITY_ACTION_FAILED, processInstanceData);
};

PostMessageEventHandler.subscribe("MULTIPLE_APPROVAL", approveForm);
PostMessageEventHandler.subscribe("MULTIPLE_REJECTION", rejectForm);
